<template>
  <div>
    <CommonDialog v-model:is-active="configModalActive">
      <template #content>
        <MaxFlexConfigEditor
          v-if="!showLayout"
          :config="model"
          @close="configModalActive = false"
          @change-layout="changeLayout"
        />
        <MaxFlexList
          v-if="showLayout"
          @selected="layoutSelected"
          @cancel="cancel"
        />
      </template>
    </CommonDialog>
    <v-btn
      color="warning"
      prepend-icon="mdi-cog"
      class="my-3"
      @click="configModalActive = true"
    >
      Konfigurieren
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, Ref, ref } from 'vue'

import { DEFAULT_LAYOUT_KEY_CONFIGS } from '@/apps/brelag/common/models/maxflex/defaultLayoutConfigs'
import {
  MAXFLEX_DEFAULT_CONFIG,
  MaxFlexConfig,
} from '@/apps/brelag/common/models/maxflex/maxflex'
import MaxFlexConfigEditor from '@/apps/brelag/mandator-user/components/editor/maxflex/MaxFlexConfigEditor.vue'
import MaxFlexList from '@/apps/brelag/mandator-user/components/editor/maxflex/MaxFlexList.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { simpleCopy } from '@/util/util'

const model = defineModel<MaxFlexConfig>()

const configModalActive = ref(false)
const showLayout = ref(false)
const previousLayoutValue: Ref<number> = ref(null)

onMounted(() => {
  if (!layoutDefined.value) {
    showLayout.value = true
  }
  if (!model.value) {
    // Load default config
    model.value = MAXFLEX_DEFAULT_CONFIG
  }

  // add empty strings if the text and icon fields do not exist to make sure the properties are reactive
  let shouldRefresh = false
  ;(model.value as MaxFlexConfig)?.keys.forEach((key) => {
    if (!key.Icon) {
      shouldRefresh = true
      key.Icon = { value: '' }
    }
    if (!key.Text) {
      shouldRefresh = true
      key.Text = { value: '' }
    }
  })
  if (shouldRefresh) {
    model.value = JSON.parse(JSON.stringify(model.value))
  }
})

const layoutDefined = computed(() => {
  return model.value && model.value.KeyLayout && model.value.KeyLayout.value
})

function changeLayout() {
  showLayout.value = true
}

function layoutSelected(value: number) {
  showLayout.value = false
  if (!model.value) {
    model.value = simpleCopy(MAXFLEX_DEFAULT_CONFIG)
  }
  // If we have a default key configuration for this layout, apply this
  if (DEFAULT_LAYOUT_KEY_CONFIGS[value]) {
    model.value['keys'] = simpleCopy(DEFAULT_LAYOUT_KEY_CONFIGS[value])
  }

  model.value['KeyLayout'] = {
    value,
  }
  previousLayoutValue.value = value
}

function cancel() {
  showLayout.value = false
}
</script>

<style></style>
